module.exports = __webpack_public_path__ + "static/en-1-b8b8419dbe60cd1b575472d09b6bf01e.png";